/* PDP mobile UX pass (audit 06.10.2026, docs/PDP_MOBILE_UX_AUDIT_2026-10.md).
   Additive: reads the DOM that pdp-used-phone.js and aioo-o2o.js already render, never writes to the cart. */
(function () {
  'use strict';

  if (!document.querySelector('.pdp-v2-accessory-page')) return;

  /* Scope mobile accessory rules without body:has (classifier-safe). */
  document.documentElement.classList.add('pdp-mobile-accessory-ux');

  var i18n = {};
  try {
    var i18nEl = document.getElementById('PdpUxI18n');
    if (i18nEl) i18n = JSON.parse(i18nEl.textContent) || {};
  } catch (_e) { /* strings stay empty, features that need them are skipped */ }

  function observe(el, opts, fn) {
    if (!el || !window.MutationObserver) return;
    new MutationObserver(fn).observe(el, opts);
  }

  /* 1. Swatches: expose the selected colour to assistive tech (it was only visual) */
  function syncSwatchState() {
    document.querySelectorAll('.pdp-v2__color').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.classList.contains('is-selected') ? 'true' : 'false');
    });
  }

  /* 2. Model trigger: announce the open sheet */
  function syncModelExpanded() {
    var open = document.documentElement.classList.contains('pdp-accessory-model-open');
    document.querySelectorAll('.pdp-accessory-model__trigger').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* 3. Sticky bar: "Melna · iPhone 17 Pro Max" so the shopper knows what the button adds */
  function stickySummary() {
    var title = document.querySelector('.sticky-atc-bar__title');
    if (!title) return;
    var colorLabel = document.querySelector('.pdp-accessory-model__color .pdp-v2__label, [data-pdp-v2-color-label]');
    var color = '';
    if (colorLabel) {
      var txt = colorLabel.textContent.trim();
      var idx = txt.indexOf(':');
      color = idx > -1 ? txt.slice(idx + 1).trim() : '';
    }
    var modelEl = document.querySelector('.pdp-accessory-model__trigger-body');
    var model = modelEl ? modelEl.textContent.trim() : '';
    var summary = [color, model].filter(Boolean).join(' · ');
    if (title.textContent !== summary) title.textContent = summary;
  }

  /* 4. Pickup row: tell the truth per variant (event comes from aioo-o2o.js) */
  function onStoreCounts(e) {
    var el = document.querySelector('[data-pdp-pickup-title]');
    var d = e && e.detail;
    if (!el || !d || !i18n.pickupStock || !i18n.pickupOrder) return;
    el.textContent = d.inStores > 0
      ? i18n.pickupStock.replace('__COUNT__', String(d.inStores))
      : i18n.pickupOrder;
  }
  document.addEventListener('aioo:o2o:counts', onStoreCounts);

  /* 5. Description: show ~6 lines, "Read more" for the rest */
  function clampDescription() {
    var body = document.querySelector('.pdp-v2-acc-about__body');
    if (!body || body.getAttribute('data-ux-clamp-bound') || !i18n.readMore) return;
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    if (body.scrollHeight < 280) return;
    body.setAttribute('data-ux-clamp-bound', 'true');
    body.classList.add('pdp-ux-clamp');
    body.setAttribute('data-clamped', 'true');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pdp-ux-clamp__toggle';
    btn.textContent = i18n.readMore;
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var clamped = body.getAttribute('data-clamped') === 'true';
      body.setAttribute('data-clamped', clamped ? 'false' : 'true');
      btn.textContent = clamped ? i18n.readLess : i18n.readMore;
      btn.setAttribute('aria-expanded', clamped ? 'true' : 'false');
    });
    body.insertAdjacentElement('afterend', btn);
  }

  function init() {
    syncSwatchState();
    syncModelExpanded();
    stickySummary();
    clampDescription();

    observe(document.querySelector('.pdp-v2__colors'), { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] }, function () {
      syncSwatchState();
      stickySummary();
    });
    observe(document.documentElement, { attributes: true, attributeFilter: ['class'] }, syncModelExpanded);
    observe(document.querySelector('.pdp-accessory-model'), { subtree: true, childList: true, characterData: true }, stickySummary);
    observe(document.querySelector('.pdp-accessory-model__color'), { subtree: true, childList: true, characterData: true }, stickySummary);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // The swatches and the deferred description are rendered by other scripts after DOMContentLoaded.
  window.setTimeout(init, 1200);
})();
